export default {
    STRING: 1,
    DECIMAL: 2,
    INTEGER: 3,
    DATE: 4,
    URL: 5,
    EMAIL: 6,
    BOOLEAN: 7
}